/**
 * Birthday display-format ("Aug 9" / "August 9") → backend ISO ("2000-08-09").
 *
 * The backend stores birthdays as YYYY-MM-DD with a year-2000 sentinel (only
 * month/day are collected — see AuthViewModel.completeProfile, which uses the
 * same convention at sign-up). Returns null when the input isn't a recognized
 * display format or an ISO date.
 */
const MONTH_TO_MM: Record<string, string> = {
  Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
  Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12',
  January: '01', February: '02', March: '03', April: '04',
  June: '06', July: '07', August: '08', September: '09',
  October: '10', November: '11', December: '12',
}

export function birthdayDisplayToISO(display: string): string | null {
  const trimmed = display.trim()
  if (!trimmed) return null
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed

  const [monthPart, dayPart] = trimmed.split(' ')
  if (!monthPart || !dayPart) return null
  const mm = MONTH_TO_MM[monthPart]
  const day = parseInt(dayPart, 10)
  if (!mm || isNaN(day) || day < 1 || day > 31) return null
  return `2000-${mm}-${String(day).padStart(2, '0')}`
}
